<template>
  <modal
    name="bug-report-modal"
    :click-to-close="false"
    width="560px"
    height="auto"
    class="modal-custom bug-report-modal"
    transition="easeInOut"
    @before-open="resetForm"
    @opened="focusCategory"
  >
    <md-card class="modal-header-custom">
      <md-dialog-title>
        <span class="neutral_1 heading-500 text-header-modal">Báo cáo lỗi</span>
        <span class="material-icons float-right cursor-pointer" @click="close">close</span>
      </md-dialog-title>
    </md-card>
    <md-card-content>
      <label class="bug-report-modal__label">Loại lỗi <span class="required">*</span></label>
      <select v-model="category" class="bug-report-modal__select">
        <option v-for="item in categories" :key="item.value" :value="item.value">
          {{ item.label }}
        </option>
      </select>

      <label class="bug-report-modal__label mt-16">Mô tả lỗi <span class="required">*</span></label>
      <textarea
        v-model="description"
        class="bug-report-modal__textarea"
        rows="5"
        maxlength="5000"
        placeholder="Mô tả chi tiết lỗi bạn gặp phải..."
      />

      <label class="bug-report-modal__label mt-16">File đính kèm</label>
      <div class="bug-report-modal__drop" @click="openFilePicker">
        <input
          ref="fileInput"
          type="file"
          multiple
          accept="image/*,video/*"
          hidden
          @change="onFilesSelected"
        />
        <md-icon>attach_file</md-icon>
        <div>
          <div class="text-400-medium">Chọn ảnh hoặc video</div>
          <div class="text-200-default neutral_2">Tối đa 2 file · Ảnh tối đa 2MB · Video tối đa 10MB</div>
        </div>
      </div>
      <p v-if="fileError" class="bug-report-modal__error">{{ fileError }}</p>
      <div v-if="previews.length" class="bug-report-modal__previews">
        <div v-for="(item, index) in previews" :key="item.id" class="bug-report-modal__preview">
          <img v-if="item.kind === 'image'" :src="item.url" :alt="item.name" />
          <video v-else :src="item.url" muted />
          <button type="button" class="bug-report-modal__remove" @click.stop="removeFile(index)">×</button>
          <span class="bug-report-modal__fname">{{ item.name }}</span>
        </div>
      </div>
    </md-card-content>
    <div class="bug-report-modal__footer">
      <button type="button" class="btn-ghost" @click="close">Hủy</button>
      <button type="button" class="btn-primary" :disabled="isSubmitting" @click="submit">
        {{ isSubmitting ? "Đang gửi..." : "Gửi báo cáo" }}
      </button>
    </div>
  </modal>
</template>

<script>
import BugReportService from "../../../store/services/BugReportService";
import {
  BUG_REPORT_CATEGORIES,
  BUG_REPORT_IMAGE_MAX_BYTES,
  BUG_REPORT_VIDEO_MAX_BYTES,
  BUG_REPORT_MAX_FILES,
} from "../../../helper/bugReport";

export default {
  name: "BugReportModal",
  data() {
    return {
      categories: BUG_REPORT_CATEGORIES,
      category: "social",
      description: "",
      files: [],
      previews: [],
      fileError: "",
      isSubmitting: false,
    };
  },
  methods: {
    focusCategory() {},
    resetForm() {
      this.category = "social";
      this.description = "";
      this.clearPreviews();
      this.files = [];
      this.fileError = "";
      this.isSubmitting = false;
    },
    close() {
      this.$modal.hide("bug-report-modal");
    },
    openFilePicker() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    onFilesSelected(event) {
      const selected = Array.from(event.target.files || []);
      event.target.value = "";
      this.fileError = "";
      for (const file of selected) {
        const err = this.validateFile(file);
        if (err) {
          this.fileError = err;
          continue;
        }
        if (this.files.length >= BUG_REPORT_MAX_FILES) {
          this.fileError = `Tối đa ${BUG_REPORT_MAX_FILES} file.`;
          break;
        }
        this.files.push(file);
        this.previews.push({
          id: `${file.name}-${file.size}-${Date.now()}`,
          name: file.name,
          kind: file.type.indexOf("video/") === 0 ? "video" : "image",
          url: URL.createObjectURL(file),
        });
      }
    },
    validateFile(file) {
      const isVideo = file.type.indexOf("video/") === 0;
      const isImage = file.type.indexOf("image/") === 0;
      if (!isVideo && !isImage) {
        return "Chỉ chấp nhận ảnh hoặc video.";
      }
      if (isImage && file.size > BUG_REPORT_IMAGE_MAX_BYTES) {
        return `${file.name} vượt quá 2MB.`;
      }
      if (isVideo && file.size > BUG_REPORT_VIDEO_MAX_BYTES) {
        return `${file.name} vượt quá 10MB.`;
      }
      return "";
    },
    removeFile(index) {
      const preview = this.previews[index];
      if (preview && preview.url) {
        URL.revokeObjectURL(preview.url);
      }
      this.previews.splice(index, 1);
      this.files.splice(index, 1);
    },
    clearPreviews() {
      this.previews.forEach((item) => {
        if (item.url) URL.revokeObjectURL(item.url);
      });
      this.previews = [];
    },
    async submit() {
      if (!this.category) {
        this.$store.dispatch("alerts/error", "Chọn loại lỗi.");
        return;
      }
      const text = String(this.description || "").trim();
      if (!text) {
        this.$store.dispatch("alerts/error", "Nhập mô tả lỗi.");
        return;
      }
      this.isSubmitting = true;
      try {
        const form = new FormData();
        form.append("category", this.category);
        form.append("description", text);
        this.files.forEach((file) => form.append("files[]", file));
        const res = await BugReportService.create(form);
        if (res && res.status) {
          this.$store.dispatch("alerts/success", "Đã gửi báo cáo lỗi.");
          this.close();
        } else {
          this.$store.dispatch("alerts/error", (res && res.message) || "Gửi báo cáo thất bại.");
        }
      } catch (e) {
        this.$store.dispatch("alerts/error", "Gửi báo cáo thất bại.");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  beforeDestroy() {
    this.clearPreviews();
  },
};
</script>

<style scoped lang="scss">
.bug-report-modal__label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
.mt-16 {
  margin-top: 16px;
}
.required {
  color: #e11d48;
}
.bug-report-modal__select,
.bug-report-modal__textarea {
  width: 100%;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  background: #fff;
}
.bug-report-modal__textarea {
  resize: vertical;
}
.bug-report-modal__drop {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px dashed #c5c9d6;
  border-radius: 10px;
  padding: 14px;
  cursor: pointer;
  background: #f8f9fc;
}
.bug-report-modal__error {
  color: #dc2626;
  font-size: 13px;
  margin-top: 8px;
}
.bug-report-modal__previews {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}
.bug-report-modal__preview {
  position: relative;
  width: 96px;
  img,
  video {
    width: 96px;
    height: 72px;
    object-fit: cover;
    border-radius: 8px;
    background: #111;
  }
}
.bug-report-modal__remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background: #111;
  color: #fff;
  cursor: pointer;
  line-height: 18px;
}
.bug-report-modal__fname {
  display: block;
  font-size: 11px;
  width: 96px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bug-report-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 16px 16px;
}
.btn-ghost,
.btn-primary {
  border-radius: 8px;
  padding: 8px 14px;
  cursor: pointer;
}
.btn-ghost {
  border: 1px solid #d8dae5;
  background: #fff;
}
.btn-primary {
  border: none;
  background: #2563eb;
  color: #fff;
}
.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
